import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgActiveScheduledCommandIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 17,
	viewBox: "0 0 8 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 8.5021L2.34434e-07 16.7272L9.53683e-07 0.272758L8 8.5021Z",
		fill: "#1377E7"
	})
});
export default SvgActiveScheduledCommandIcon;
